import styled from '@emotion/styled';
import { Link } from '@material-ui/core';

export const MentionsTextLink = styled(Link)`
  word-wrap: break-word;
`;
